module.exports = __webpack_public_path__ + "img/16-1_02.fced23e9.jpg";